import React from "react";

export default function renderIcon({ width = 14, height = 14, color = "#4B1E78" }) {
  return (
    <svg width={width} height={height} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M9 3h6a1 1 0 0 1 1 1v1h4a1 1 0 1 1 0 2h-1.07l-.86 12.04A3 3 0 0 1 15.08 22H8.92a3 3 0 0 1-2.99-2.96L5.07 7H4a1 1 0 1 1 0-2h4V4a1 1 0 0 1 1-1Zm1 2h4V5h-4v0ZM7.08 7l.85 11.9a1 1 0 0 0 1 .93h6.15a1 1 0 0 0 .99-.93L16.92 7H7.08ZM10 10a1 1 0 0 1 1 1v6a1 1 0 1 1-2 0v-6a1 1 0 0 1 1-1Zm4 0a1 1 0 0 1 1 1v6a1 1 0 1 1-2 0v-6a1 1 0 0 1 1-1Z"
        fill={color}
      />
    </svg>
  );
}
